import { inject, Service } from '@angular/core';
import { PlatformService } from './platform.service';

@Service()
export class AuthService {
  readonly #platform = inject(PlatformService);

  get isLoggedIn() {
    return this.#platform.isLoggedIn;
  }

  constructor() {
    this.#platform.initialize();
  }

  login() {
    return this.#platform.login();
  }

  refresh() {
    return this.#platform.refresh();
  }

  logout() {
    this.#platform.logout();
  }
}
